import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Editor } from '@tinymce/tinymce-react';
import axios from 'axios';

function EditCourseContent() {
  const API_URL = process.env.REACT_APP_API_URL;
  const [content, setContent] = useState('');
  const { interfaceLang, courseLang, courseSlug } = useParams();  // Récupère l'ID du cours à partir de l'URL
  useEffect(() => {
    const token = localStorage.getItem('access_token');

    // Récupérer contenu HTML du cours
    axios.get(`${API_URL}/cours/api/courses-detail/${courseSlug}/`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }).then(response => setContent(response.data.content))
      .catch(error => console.error("Erreur lors du chargement du cours :", error));
  }, [courseSlug]);

  const handleSave = () => {
    const token = localStorage.getItem('access_token');

    // Requête pour sauvegarder le token
    axios.put(`${API_URL}/cours/api/courses-update/${courseSlug}/`, { content }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }).then(() => alert("Contenu mis à jour avec succès !"))
      .catch(error => console.error("Erreur lors de la sauvegarde :", error));
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-4">Édition du contenu du cours</h1>
      <Editor
        tinymceScriptSrc='/tinymce/tinymce.min.js'
        licenseKey='your-license-key'
        
        value={content}

        init={{
            height: 500,
            menubar: true,
            plugins: 'lists link image table code',
            toolbar: 'undo redo | formatselect | bold italic underline | alignleft aligncenter alignright | bullist numlist | code',
            content_css: '/css/tailwind.css', // Inclure le CSS Tailwind pour le rendu
            script_url: '/tinymce/tinymce.min.js', // Chemin vers votre version locale de TinyMCE
            valid_elements: '*[*]', // Autorise tous les éléments et attributs
            extended_valid_elements: 'div[class],p[class],ul[class],li[class],span[class],h2[class],h3[class],blockquote[class]', // Autorise les classes sur ces éléments
            entity_encoding: 'raw', // Ne pas encoder les entités HTML
            forced_root_block: false, // Éviter d'ajouter des <p> autour de tout
            valid_styles: {
            '*': '', // Permet uniquement les classes pour le style
            },
        }}
        onEditorChange={(newContent) => setContent(newContent)}
      />
      <button
        onClick={handleSave}
        className="mt-4 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition"
      >
        Sauvegarder
      </button>
    </div>
  );
}

export default EditCourseContent;
